module.exports = __webpack_public_path__ + "img/iconsWhatsapp.c4cfa51c.svg";